import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const PluginGroupPermissionGate = (props: Omit<BasePermissionGateProps<"plugin">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="plugin"
		/>
	)
}

export default PluginGroupPermissionGate
